import { createContext, useContext } from 'react'
import { type IPP_SUPPORTED_LOCALE } from './intl.types'

export type I18nContextValue = {
  locale: IPP_SUPPORTED_LOCALE
  setLocale: (locale: IPP_SUPPORTED_LOCALE) => void
}

export const I18nContext = createContext<I18nContextValue | null>(null)

export const useI18nContext = () => {
  const i18nContext = useContext(I18nContext)
  if (!i18nContext) {
    throw new Error('useI18nContext must be used within an I18nContextProvider')
  }
  return i18nContext
}
